import React from 'react';
import {Outlet, Route, Routes, useSearchParams} from 'react-router-dom';
import CompassPlusResetPassword from './pages/compass_plus/ResetPassword';
import EANRegisterResetPassword from './pages/eanr/ResetPassword';
import CompassPlusLogin from './pages/compass_plus/Login';
import EANRegisterLogin from './pages/eanr/Login';
import CompassPlusPhoneNumberSetup from './pages/compass_plus/PhoneNumberSetup';
import EANRegisterPhoneNumberSetup from './pages/eanr/PhoneNumberSetup';
import SchoolshubPhoneNumberSetup from './pages/schoolshub/PhoneNumberSetup';
import CLTPLogin from './pages/cltp/Login';
import SchoolshubLogin from './pages/schoolshub/Login';
import SchoolshubResetPassword from './pages/schoolshub/ResetPassword';
import DigitalhubOauthLandingPage from './pages/digitalhub/OauthLandingPage';
import RedirectToCompassPlus from './components/RedirectToCompassPlus';
import Impersonate from './pages/impersonate/Impersonate';
import {
    isSchoolshubSystemAdminLogin,
    rememberSchoolshubSystemAdminLogin,
    SCHOOLSHUB_SYSTEM_ADMIN_QUERY_PARAMETER,
} from './schoolshubRouting';

const ImportGlobalStyles = React.lazy(() => import('./ImportCompassPlusStyles'));
const ImportDigitalhubStyles = React.lazy(() => import('./ImportDigitalhubStyles'));
const ImportSchoolshubStyles = React.lazy(() => import('./ImportSchoolshubStyles'));

export const PATH_BASE = '/:route?/:extra?';

const PATH_RESET_PASSWORD_CODE = 'reset-password/:code';
const PATH_RESET_PASSWORD = 'reset-password';
const PATH_TEXT_MESSAGE_SETUP = 'phone-number-setup/:params';
const PATH_RESET_PASSWORD_SUCCESS = '/?reset-password-success';
const PATH_PHONE_NUMBER_SETUP_SUCCESS = '/?phone-number-setup-success'

export const PATH_COMPASS_PLUS = '/compassplus';
export const PATH_COMPASS_PLUS_RESET_PASSWORD_SUCCESS = PATH_COMPASS_PLUS + PATH_RESET_PASSWORD_SUCCESS;
export const PATH_COMPASS_PLUS_RESET_PASSWORD = PATH_COMPASS_PLUS + '/' + PATH_RESET_PASSWORD;

export const PATH_COMPASS_PLUS_TEXT_MESSAGE_SETUP_SUCCESS = PATH_COMPASS_PLUS + PATH_PHONE_NUMBER_SETUP_SUCCESS;
export const PATH_COMPASS_PLUS_IMPERSONATE_USER = PATH_COMPASS_PLUS + '/impersonate/:email/:emailToImpersonate';

export const PATH_EAN_REGISTER = '/eanr';
export const PATH_EAN_REGISTER_RESET_PASSWORD_SUCCESS = PATH_EAN_REGISTER + PATH_RESET_PASSWORD_SUCCESS;
export const PATH_EAN_REGISTER_TEXT_MESSAGE_SETUP_SUCCESS = PATH_EAN_REGISTER + PATH_PHONE_NUMBER_SETUP_SUCCESS;

export const PATH_CLTP = '/cltp';

export const PATH_SCHOOLSHUB = '/schoolshub';
export const PATH_SCHOOLSHUB_SYSTEM_ADMIN = PATH_SCHOOLSHUB + `?${SCHOOLSHUB_SYSTEM_ADMIN_QUERY_PARAMETER}=true`;
export const PATH_SCHOOLSHUB_RESET_PASSWORD_SUCCESS = PATH_SCHOOLSHUB + PATH_RESET_PASSWORD_SUCCESS;
export const PATH_SCHOOLSHUB_TEXT_MESSAGE_SETUP_SUCCESS = PATH_SCHOOLSHUB + PATH_PHONE_NUMBER_SETUP_SUCCESS;

export const PATH_DIGITALHUB_OAUTH = '/digitalhub/oauth';

const GlobalLayout = () => (
    <>
      <ImportGlobalStyles />
      <Outlet />
    </>
);

const SchoolshubLayout = () => (
    <>
      <ImportSchoolshubStyles />
      <Outlet />
    </>
);

const SchoolshubLoginRoute = () => {
    const [searchParams] = useSearchParams();
    const isSystemAdminLogin = isSchoolshubSystemAdminLogin(searchParams, window.sessionStorage);

    React.useEffect(() => {
        rememberSchoolshubSystemAdminLogin(searchParams, window.sessionStorage);
    }, [searchParams]);

    return isSystemAdminLogin ? <SchoolshubLogin /> : <RedirectToCompassPlus />;
};

const Router = () => {
  return (
    <React.Suspense fallback={<></>}>

      <Routes>
        {/* Digital Hub (and don't load global CSS)  */}
        <Route path={PATH_DIGITALHUB_OAUTH} element={
          <>
            <ImportDigitalhubStyles />
            <DigitalhubOauthLandingPage />
          </>
        } />

        {/* Load CSS for everything else */}
        <Route path="/" element={<GlobalLayout />}>
          {/* Compass+ */}
          <Route path={PATH_COMPASS_PLUS} element={<Outlet />}>
            <Route index element={<CompassPlusLogin />} />
            <Route path={PATH_TEXT_MESSAGE_SETUP} element={<CompassPlusPhoneNumberSetup />} />
            <Route path={PATH_RESET_PASSWORD} element={<CompassPlusResetPassword />} />
            <Route path={PATH_RESET_PASSWORD_CODE} element={<CompassPlusResetPassword />} />
          </Route>

          {/* EAN-Register */}
          <Route path={PATH_EAN_REGISTER} element={<Outlet/>}>
            <Route index element={<EANRegisterLogin />} />
            <Route path={PATH_TEXT_MESSAGE_SETUP} element={<EANRegisterPhoneNumberSetup />} />
            <Route path={PATH_RESET_PASSWORD} element={<EANRegisterResetPassword />} />
            <Route path={PATH_RESET_PASSWORD_CODE} element={<EANRegisterResetPassword />} />
          </Route>

          {/* CLTP */}
          <Route path={PATH_CLTP} element={<CLTPLogin />} />

          {/* Schoolshub */}
          <Route path={PATH_SCHOOLSHUB} element={<SchoolshubLayout />}>
            <Route index element={<SchoolshubLoginRoute />} />
            <Route path={PATH_TEXT_MESSAGE_SETUP} element={<SchoolshubPhoneNumberSetup />} />
            <Route path={PATH_RESET_PASSWORD} element={<SchoolshubResetPassword />} />
            <Route path={PATH_RESET_PASSWORD_CODE} element={<SchoolshubResetPassword />} />
          </Route>

          <Route path={PATH_COMPASS_PLUS_IMPERSONATE_USER} element={
            <>
              <ImportDigitalhubStyles />
              <Impersonate />
            </>
          } />

          <Route path={PATH_BASE} element={<RedirectToCompassPlus />} />
        </Route>
      </Routes>
    </React.Suspense>
  );
};

export default Router;
